/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LogsModule
 */

import { Component } from '@angular/core';
import { L10nService } from '@vmw/ngx-vip';

import * as l10n from './log-cinematic-section-dns.l10n';
import { TrafficLogCinematicStore } from '../../traffic-logs/traffic-log-cinematic/traffic-log-cinematic.store';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description
 *     Component for displaying DNS section in a traffic log cinematic view.
 * @author Zhiqian Liu
 */
@Component({
    selector: 'log-cinematic-section-dns',
    templateUrl: './log-cinematic-section-dns.component.html',
})
export class LogCinematicSectionDnsComponent {
    public readonly dnsRequestInfo$ = this.logCinematicStore.dnsRequestInfo$;

    public readonly dnsResponseInfo$ = this.logCinematicStore.dnsResponseInfo$;

    public readonly l10nKeys = l10nKeys;

    constructor(
        private readonly logCinematicStore: TrafficLogCinematicStore,
        l10nService: L10nService,
    ) {
        l10nService.registerSourceBundles(dictionary);
    }
}
